import {observe} from '@github/selector-observer'
import poof from '../behaviors/confetti'

observe('.js-confetti-party', () => {
  poof()
})
